import { apiSlice } from "../../app/api/apiSlice";

export const blogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Inside your blogApiSlice.js file, rewrite the query configuration block:
    // Inside your blogApiSlice.js file, update your query hook structure:
    getBlogPosts: builder.query({
      query: ({
        page = 1,
        limit = 6,
        adminMode = false,
        search = "",
        category = "",
      }) =>
        `/blog?page=${page}&limit=${limit}&adminMode=${adminMode}&search=${encodeURIComponent(
          search
        )}&category=${encodeURIComponent(category)}`,
      providesTags: ["Blog"],
    }),

    updateBlogPost: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/blog/${id}`,
        method: "PUT",
        body: formData, // FormData handles the text combined with raw image asset binary blocks
      }),
      invalidatesTags: ["Blog"],
    }),

    getBlogPostBySlug: builder.query({
      query: (slug) => `/blog/${slug}`,
      providesTags: (result, error, slug) => [{ type: "Blog", id: slug }],
    }),
    createBlogPost: builder.mutation({
      query: (formData) => ({
        url: "/blog",
        method: "POST",
        body: formData, // FormData contains the text string elements combined with raw binary image bytes
      }),
      invalidatesTags: ["Blog"],
    }),
    deleteBlogPost: builder.mutation({
      query: (id) => ({
        url: `/blog/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Blog"],
    }),
  }),
});

export const {
  useGetBlogPostsQuery,
  useGetBlogPostBySlugQuery,
  useCreateBlogPostMutation,
  useDeleteBlogPostMutation,
  useUpdateBlogPostMutation,
} = blogApiSlice;
